import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
  Alert,
} from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';

const SystemRecordsMaster = () => {
  const navigate = useNavigate();
  const [hoverIndex, setHoverIndex] = useState(null);

  let records = [

    { name: "System Parameter", flag: "system", uiFlag: "system", bgColor: "#f8d7da" },

    { name: "Issue Ch. {FH} { Agrment }", flag: "issue_challan_agr", uiFlag: "challan", bgColor: "#cce5ff" },
    { name: "Receive Ch. {FH} { Agrment }", flag: "issue_recipted_agr", uiFlag: "challan", bgColor: "#fff3cd" },
    { name: "Issue Ch. { General }", flag: "issue_challan_single", uiFlag: "challan", bgColor: "#d4edda" },
    { name: "Receive Ch. { General }", flag: "issue_recipted", uiFlag: "challan", bgColor: "#fff3cd" },
    { name: "Issue Sale", flag: "issue_sale", uiFlag: "challan", bgColor: "#f5c6cb" },
    { name: "Optical Ch. { General }", flag: "issue_challan_optical", uiFlag: "challan", bgColor: "#fff3cd" },
    { name: "Exporter Ch. { General }", flag: "issue_challan_exporter", uiFlag: "challan", bgColor: "#cce5ff" },

    { name: "Material Ch. { General }", flag: "material_challan_single", uiFlag: "challan", bgColor: "#d4edda" },

    { name: "Sale Ch. { General }", flag: "sale_challan_single", uiFlag: "challan", bgColor: "#d4edda" },


    { name: "Party Detail", flag: "party_detail", uiFlag: "party", bgColor: "#fff3cd" },
    { name: "Item Detail", flag: "item_detail", uiFlag: "item", bgColor: "#f5c6cb" },

    // { name: "Issue Purchase", flag: "issue_purchase", bgColor: "#d1ecf1" },
    // { name: "Issue Sale Return", flag: "issue_sale_return", bgColor: "#f8d7da" },
    // { name: "Issue Purchase Return", flag: "issue_purchase_return", bgColor: "#d4edda" },
    // { name: "Party Agreement Item Detail", flag: "system_party_aggrement", bgColor: "#cce5ff" },  // original flag name  : "system"
    { name: "Voucher Master", flag: "voucher", bgColor: "#f5c6cb" },   // original flag name voucher_recipted,voucher_payment,voucher_contra,voucher_journal,voucher_credit,voucher_debit
    // { name: "Housekeeper Master", flag: "housekeeper", bgColor: "#d1ecf1" },
    // { name: "Room Service Master", flag: "book_room_service", bgColor: "#fff3cd" }
  ];


  // [
  //   { "name": "System Detail", "flag": "system" },
  //   { "name": " Issue Challan Single (Array)", "flag": "issue_challan_single" },
  //   { "name": " Issue Challan (OH) Aggrement ", "flag": "issue_challan_agr" },
  //   { "name": " Issue Receive", "flag": "issue_recipted" },
  //   { "name": " Issue Sale", "flag": "issue_sale" },
  //   { "name": " Issue Purchase", "flag": "issue_purchase" },
  //   { "name": " Issue Sale Return", "flag": "issue_sale_return" },
  //   { "name": " Issue Purchase Return", "flag": "issue_purchase_return" },
  //   { "name": " Party Agreement Item Detail", "flag": "system_party_aggrement" }, // original flag name  : "system"
  //   {
  //     "name": " Voucher Master",
  //     "flag": "voucher",  // original flag name voucher_recipted,voucher_payment,voucher_contra,voucher_journal,voucher_credit,voucher_debit
  //   },
  //   { "name": " Housekeeper Master", "flag": "housekeeper" },
  //   { "name": " Room Service Master", "flag": "book_room_service" }
  // ]

  const goToNewTab = (flag, title, uiFlag) => {
    const currentUrl = `${window.location.origin}`;
    const url = `${currentUrl}/systemRecords?flag=${flag}&title=${title}&uiFlag=${uiFlag}`;
    window.open(url, '_blank');
  };

  return (
    <>
      <Col lg='12'>
        <Card className='bg-white pd-10 card-box mb-30'>
          <CardTitle
            tag='h6'
            className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
          >
            <div className='d-flex align-items-center'>
              <i className='bi bi-card-text mr-2'></i>
              System Records
            </div>

            <Row
              className='align-items-center'
              style={{ marginRight: '10px', width: '300px' }}
            >
              <Input
                id='search'
                name='search'
                placeholder='Search...'
                type='text'
              // onChange={(e) => {
              //   onHandleSearchKeyItem(e);
              // }}
              />
            </Row>


          </CardTitle>
          <CardBody>
            <div style={{}}>
              {/* <h2 style={styles.heading}>Select an Option</h2> */}
              <div style={styles.optionsWrapper}>
                {/* {records.map((item, index) => (
                  // <span
                  //   key={index}
                  //   style={styles.option}

                  //   onClick={() => { goToNewTab(item.flag) }}
                  //   onMouseOver={(e) => (e.target.style.backgroundColor = styles.optionHover.backgroundColor)}
                  //   onMouseOut={(e) => (e.target.style.backgroundColor = styles.option.backgroundColor)}
                  // >
                  //   {item.name}
                  // </span>
                  <div key={index}
                    onClick={() => { goToNewTab(item.flag) }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = styles.optionHover.backgroundColor)}
                    onMouseOut={(e) => (e.target.style.backgroundColor = styles.option.backgroundColor)}
                    style={{ backgroundColor: item.bgColor, padding: "10px", marginBottom: "5px", borderRadius: "5px" }}>
                    {item.name}
                  </div>
                ))} */}

                <div style={{}}>
                  {records.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => goToNewTab(item.flag, item.name, item.uiFlag)}
                      onMouseEnter={() => setHoverIndex(index)}
                      onMouseLeave={() => setHoverIndex(null)}
                      style={{
                        backgroundColor: hoverIndex === index ? "#b3b3b3" : item.bgColor, // Greyish hover effect
                        padding: "10px",
                        marginBottom: "5px",
                        borderRadius: "5px",
                        cursor: "pointer",
                        transition: "background-color 0.3s ease",
                        float: "left",
                        margin: 10,
                        minWidth: "30%",
                        textAlign: "center"
                      }}
                    >
                      {item.name}
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </CardBody>
        </Card>
      </Col >
    </>
  );
};


const styles = {
  container: {
    padding: "16px",
    border: "1px solid #ddd",
    borderRadius: "10px",
    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#f9f9f9",
    maxWidth: "600px",
    margin: "20px auto",
    textAlign: "center",
  },
  heading: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  optionsWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
  },
  option: {
    padding: "18px 16px",
    backgroundColor: "#007bff",
    color: "#fff",
    fontSize: "14px",
    borderRadius: "20px",
    cursor: "pointer",
    boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.2)",
    transition: "background-color 0.3s ease",
    // minHeight: "50px"
  },
  optionHover: {
    backgroundColor: "#0056b3",
  },


};

export default SystemRecordsMaster;



